import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';
import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { createReducer } from 'utils/redux';
import { API, destroy, get } from 'utils/api';
import { logError } from 'utils/log';

import type { Action, Dispatch, ThunkAction } from 'types';
import type {
  CollectionsBulkDeleteCreatorsItem,
  CollectionsBulkDeleteCreatorsState
} from 'modules/lists/components/modals/bulk-delete-creators/types';

const { LISTS } = API.END_POINTS;

const PROCESSING = 'collections/BULK_PROCESSING';
const LOADED = 'collections/BULK_LOADED';
const RESET = 'collections/BULK_RESET';

const initialState = {
  creators: [],
  isLoading: true
};

const setStatus = (status: boolean): Action => ({
  type: PROCESSING,

  payload: {
    status
  }
});

const creatorsLoaded = (creators: Array<CollectionsBulkDeleteCreatorsItem>): Action => ({
  type: LOADED,

  payload: {
    creators
  }
});

export const resetCreators = (): Action => ({
  type: RESET
});

export const fetchCreators = (orgId: number, collectionId: number, sort: string, totalItems: number): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setStatus(true));

  try {
    const url = LISTS.getBulkCreators(orgId, collectionId, sort, totalItems);
    const response = await get(url);
    const creators = response.data || [];

    dispatch(setStatus(false));

    return dispatch(creatorsLoaded(creators));
  } catch (error) {
    return logError(error);
  } finally {
    dispatch(setStatus(false));
  }
};

export const deleteCreators = (orgId: number, collectionId: number, creatorIds: Array<string>): ThunkAction => async (dispatch: Dispatch) => {
  const url = LISTS.getBulkCreators(orgId, collectionId);

  dispatch(showLoading(url));

  try {
    await destroy(url, { data: { creatorIds } });

    return dispatch(hideLoading(url));
  } catch (error) {
    return logError(error);
  } finally {
    dispatch(hideLoading(url));
  }
};

const handleProcessing = (state: CollectionsBulkDeleteCreatorsState, { status }): CollectionsBulkDeleteCreatorsState => ({
  ...state,
  isLoading: status
});

const handleLoaded = (state: CollectionsBulkDeleteCreatorsState, { creators }): CollectionsBulkDeleteCreatorsState => ({
  ...state,
  creators,
  isLoading: false
});

export default createReducer<CollectionsBulkDeleteCreatorsState, any>('collectionsBulk', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [PROCESSING]: handleProcessing,
  [LOADED]: handleLoaded
});
